import { motion } from "framer-motion";
import { BOOKING_STEPS } from "../../data/project";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#F4F2EC] py-24 md:py-36 border-t hairline"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-5">06 / Booking Process</div>
            <h2
              className="font-serif leading-[1.02] tracking-tight text-[#1A3626]"
              style={{ fontSize: "clamp(40px, 5.5vw, 78px)" }}
            >
              Four steps
              <br />
              <span className="italic font-light">to allocation.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-[#1A3626]/75 font-light leading-relaxed">
              EOIs are processed on a first-come, first-served basis. Deposit
              is held in escrow and fully refundable should no allocation be
              made.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#B3906A]/30 border hairline">
          {BOOKING_STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`process-step-${s.num}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-[#F4F2EC] p-8 md:p-10 flex flex-col min-h-[280px]"
            >
              <div className="font-serif text-[#B3906A] text-5xl md:text-6xl italic leading-none">
                {s.num}
              </div>
              <div className="mt-auto pt-8">
                <h3 className="font-serif text-2xl md:text-3xl text-[#1A3626] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#6A736E] font-light leading-relaxed text-sm md:text-base">
                  {s.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
